import _, { forEach } from "lodash";
import store from "../../redux/store";
import {
  ADD_SHOP_OFFERS_CATEGORIES,
  CLEAR_OFFERS,
  MESSAGE_MODAL,
  OFFERS_UPDATED,
  SET_PENDING_ORDER,
  SHOW_ORDER_MODAL,
  SHOW_ORDER_STATUS,
  UPDATE_CANCELED_ORDERS,
  UPDATE_DRIVERS_DATA,
  UPDATE_LAST_ORDER_CHARGE_IDS,
  UPDATE_ORDERS,
  UPDATE_PAST_ORDERS,
  UPDATE_SHOP,
  UPDATE_SHOP_IS_LOADED,
  UPDATE_SHOP_ORDERS,
} from "../../redux/actions/types";
import {
  CANCEL_CLIENT_UNAVAILABLE,
  CUSTOMER_CANCEL,
  DELIVERY_FLEET_CONFIGURATION_TYPE,
  DRIVER_CANCEL,
  DRIVERS_TYPE,
  ORDER_PHASE_DELIVERING,
  ORDER_PHASE_PREPARING,
  ORDER_TYPE_DELIVERY,
  PAYMENT,
  SHOP_CANCEL_AND_REFUND,
} from "../../constants";
import { resetPendingOrder, updateAddress } from "../../redux/actions";
import {
  checkIfCustomerAddressValid,
  getCustomerAddress,
} from "../../utils/customer-address-and-shops";
import { getFirebaseFleet, getFirebaseModule } from "./firebaseInit";
import { getDatabase, off, onValue, ref } from "firebase/database";
import { parseCategories, parseSections } from "../../utils/index.js";
import { deleteUserLastOrderChargeId } from "../users";
import { createCategoriesFromOffers } from "../../utils/offer";
import {
  isBngmOptionListOffer,
  buildBngmSyntheticCategories,
} from "../../utils/bngmOffer";
import { getBngmOptionListKey } from "../../utils/marketingCampaign";

export const unlistenFirebase = (customerId) => {
  if (!customerId) return;

  const db = getDatabase(getFirebaseModule());
  off(ref(db, `/users/${customerId}`));
  off(ref(db, `/orders/${customerId}`));
  off(ref(db, `/pendingOrders/${customerId}`));
  off(ref(db, `/pastOrders/${customerId}`));
  off(ref(db, `/canceledOrder/${customerId}`));
};

export const listenFirebasePendingOrder = async (customerId) => {
  if (!customerId) return;

  const db = getDatabase(getFirebaseModule());
  const pendingOrderRef = ref(db, `/pendingOrders/${customerId}`);

  onValue(pendingOrderRef, async (snapshot) => {
    const pendingOrder = snapshot.val() || {};
    const commande = pendingOrder.commande || {};
    forEach(Object.keys(commande), (productKey) => {
      commande[productKey].items = commande[productKey].items ?? [];
    });

    store.dispatch({
      type: SET_PENDING_ORDER,
      payload: { ...pendingOrder, commande },
    });

    if (!pendingOrder.shopId) {
      store.dispatch(resetPendingOrder());
      return;
    }
    checkIfCustomerAddressValid(
      pendingOrder.address,
      pendingOrder.orderType,
      pendingOrder.shopId,
    );
  });
};

export const listenOrders = (shopId) => {
  if (!shopId) return;

  const db = getDatabase(getFirebaseModule());
  const ordersRef = ref(db, "/orders");

  off(ordersRef, "value");

  onValue(ordersRef, (snapshot) => {
    const ordersByCustomerId = snapshot.val() || {};
    const ordersByShopId = [];

    _.map(ordersByCustomerId, (orders) => {
      _.map(orders, (order) => {
        if (order.shopId === shopId) ordersByShopId.push(order);
      });
    });

    store.dispatch({ type: UPDATE_SHOP_ORDERS, payload: ordersByShopId });
  });
};

export const listenOffers = (shopId, orderType) => {
  if (!shopId) {
    store.dispatch({ type: CLEAR_OFFERS });
    return;
  }

  const db = getDatabase(getFirebaseModule());
  const offersRef = ref(db, "/offers");

  off(offersRef, "value");

  onValue(offersRef, async (snapshot) => {
    const offers = Object.values(snapshot.val() || {});
    const currentOrderType =
      store.getState().pendingOrderReducer?.orderType || orderType;

    const filteredOffers = _.filter(offers, (offer) => {
      if (!offer.shopIds.includes(shopId)) {
        return false;
      }

      if (!offer.orderTypes || offer.orderTypes.length === 0) {
        return true;
      }

      return offer.orderTypes.includes(currentOrderType);
    });
    const bngmOffers = filteredOffers.filter(isBngmOptionListOffer);
    const nonBngmOffers = filteredOffers.filter(
      (o) => !isBngmOptionListOffer(o),
    );
    store.dispatch({
      type: OFFERS_UPDATED,
      payload: filteredOffers,
    });
    const { categories: shopCategories } = store.getState().shopReducer;
    const bngmCategories = {};
    for (const offer of bngmOffers) {
      const config = offer.config;
      const optionListKey = getBngmOptionListKey(config);
      const optionListCategory = optionListKey
        ? shopCategories?.[optionListKey]
        : null;
      if (optionListCategory) {
        Object.assign(
          bngmCategories,
          buildBngmSyntheticCategories(offer, optionListCategory),
        );
      }
    }
    store.dispatch({
      type: ADD_SHOP_OFFERS_CATEGORIES,
      payload: {
        ...(await createCategoriesFromOffers(nonBngmOffers)),
        ...bngmCategories,
      },
    });
  });
};
export const listenLastOrderChargeId = async (customerId) => {
  if (!customerId) return;

  const db = getDatabase(getFirebaseModule());
  const lastOrderChargeIdsRef = ref(
    db,
    `/users/${customerId}/lastOrderChargeIds`,
  );

  off(lastOrderChargeIdsRef, "value");

  onValue(lastOrderChargeIdsRef, (snapshot) => {
    const lastOrderChargeIds = snapshot.val();

    store.dispatch({
      type: UPDATE_LAST_ORDER_CHARGE_IDS,
      payload: lastOrderChargeIds || {},
    });
  });
};

export const listendFirebaseOrderTables = async (
  customerId,
  updateUser,
  isUserAnonymous,
) => {
  if (!customerId) return;

  const db = getDatabase(getFirebaseModule());

  const userRef = ref(db, `/users/${customerId}`);
  onValue(userRef, async (snapshot) => {
    const customerProfile = snapshot.val() || {};
    const address = await getCustomerAddress(customerId);
    if (address) store.dispatch(updateAddress(address));
    store.dispatch(updateUser(customerProfile, customerId, isUserAnonymous));
  });

  const ordersRef = ref(db, `/orders/${customerId}`);
  onValue(ordersRef, (snapshot) => {
    const newOrders = snapshot.val() || {};
    const { orders } = store.getState().orderReducer;

    _.map(newOrders, (newOrder) => {
      const { status, idDep, chargeId, delivery = {} } = newOrder;
      const order = _.find(orders, (order) => order.chargeId === chargeId);

      if (status === ORDER_PHASE_DELIVERING && idDep)
        listenDriverData(idDep, chargeId, delivery);
      if (
        order &&
        status === ORDER_PHASE_PREPARING &&
        order.status === ORDER_PHASE_DELIVERING
      ) {
        unlistenDriverData(order.idDep, order.chargeId, delivery);
      }
    });

    store.dispatch({ type: UPDATE_ORDERS, payload: newOrders });
  });

  const pastOrdersRef = ref(db, `/pastOrders/${customerId}`);
  onValue(pastOrdersRef, async (snapshot) => {
    const pastOrders = snapshot.val() || {};

    if (_.isEmpty(pastOrders)) return;
    const { lastOrderChargeIds } = store.getState().userReducer;
    const { orders } = store.getState().orderReducer;
    const { orderStatus } = store.getState().componentReducer;

    const lastPastChargeId = _.find(
      lastOrderChargeIds,
      (lastOrderChargeId) => pastOrders[lastOrderChargeId],
    );
    if (lastPastChargeId) {
      const pastOrder = pastOrders[lastPastChargeId];
      const {
        orderNumber,
        chargeId,
        idDep,
        delivery = {},
        orderType,
      } = pastOrder;

      if (idDep) unlistenDriverData(idDep, chargeId, delivery);

      if (orderStatus === chargeId)
        store.dispatch({ type: SHOW_ORDER_STATUS, payload: false });
      if (_.isEmpty(orders))
        store.dispatch({ type: SHOW_ORDER_MODAL, payload: false });

      store.dispatch({
        type: MESSAGE_MODAL,
        payload: {
          data: {
            text: `commande ${orderType === ORDER_TYPE_DELIVERY ? "livrée" : "réceptionnée"}`,
            withImage: true,
            image: "order",
            title: `Votre commande ${orderType === ORDER_TYPE_DELIVERY ? "a été livrée." : "est prête."}`,
            subTitle: "Merci pour votre confiance. Profitez de votre repas.",
          },
        },
      });

      await deleteUserLastOrderChargeId(customerId, chargeId);
    }

    store.dispatch({ type: UPDATE_PAST_ORDERS, payload: pastOrders });
  });

  const canceledOrdersRef = ref(db, `/canceledOrder/${customerId}`);
  onValue(canceledOrdersRef, async (snapshot) => {
    const canceledOrders = snapshot.val() || {};
    if (_.isEmpty(canceledOrders)) return;
    const { lastOrderChargeIds } = store.getState().userReducer;

    const { support } = store.getState().shopReducer;
    const { orders } = store.getState().orderReducer;
    const { orderStatus } = store.getState().componentReducer;
    const lastCanceledChargeId = _.find(
      lastOrderChargeIds,
      (lastOrderChargeId) => canceledOrders[lastOrderChargeId],
    );
    if (lastCanceledChargeId) {
      const canceledOrder = canceledOrders[lastCanceledChargeId];
      const {
        cancellation,
        orderNumber,
        chargeId,
        idDep,
        delivery = {},
        paymentType,
        userCancelServicePrice,
        totalPriceOrder,
      } = canceledOrder;
      const { canceledBy, cancelReason } = cancellation;

      if (idDep) await unlistenDriverData(idDep, chargeId, delivery);

      let cancelMessage = `Le magasin n'a pas pu prendre votre commande n°${orderNumber}. ${support?.number ? `Contactez le ${support.number}.` : ""
        }`;
      if (cancelReason === CANCEL_CLIENT_UNAVAILABLE) {
        cancelMessage =
          canceledBy === DRIVER_CANCEL
            ? `Le livreur a annulé votre commande n°${orderNumber} car vous étiez injoignable.`
            : `Le magasin a annulé votre commande n°${orderNumber} car vous étiez injoignable.`;
        if (paymentType === PAYMENT.TYPE_STRIPE && userCancelServicePrice > 0) {
          cancelMessage += ` Vous avez été facturé de ${userCancelServicePrice} €.`;
        }
      }
      if (cancelReason === SHOP_CANCEL_AND_REFUND) {
        cancelMessage = `Le magasin a remboursé votre commande n°${orderNumber} d'un montant de ${totalPriceOrder} €.`;
      }

      if (canceledBy !== CUSTOMER_CANCEL) {
        store.dispatch({
          type: MESSAGE_MODAL,
          payload: { message: cancelMessage },
        });
      }
      if (orderStatus === chargeId)
        store.dispatch({ type: SHOW_ORDER_STATUS, payload: false });
      if (_.isEmpty(orders))
        store.dispatch({ type: SHOW_ORDER_MODAL, payload: false });

      await deleteUserLastOrderChargeId(customerId, chargeId);
    }

    store.dispatch({ type: UPDATE_CANCELED_ORDERS, payload: canceledOrders });
  });
};

export const listenFirebaseUsersData = async (
  customerId,
  isUserAnonymous,
  updateUser,
) => {
  unlistenFirebase(customerId);
  if (!isUserAnonymous) {
    await listenLastOrderChargeId(customerId);
  }
  await listendFirebaseOrderTables(customerId, updateUser, isUserAnonymous);
  await listenFirebasePendingOrder(customerId);
  return true;
};

export const listenShopData = async (
  previousShopId,
  shopId,
  customerAddress,
  getShopAndZoneData,
  orderType,
) => {
  const db = getDatabase(getFirebaseModule());

  if (previousShopId !== shopId) {
    store.dispatch({ type: UPDATE_SHOP_IS_LOADED, payload: false });
    store.dispatch({ type: CLEAR_OFFERS });
    off(ref(db, `/shops/${previousShopId}`));
    off(ref(db, `/menus/${previousShopId}`));
  }

  const shopRef = ref(db, `/shops/${shopId}`);
  onValue(shopRef, (snapshot) => {
    const firebaseShop = snapshot.val();
    const shop = getShopAndZoneData(
      shopId,
      firebaseShop,
      customerAddress || firebaseShop?.address,
      orderType,
    );

    if (shop) {
      const menuRef = ref(db, `/menus/${shopId}`);
      onValue(menuRef, (snapshot) => {
        const shopMenus = snapshot.val();
        if (shopMenus) {
          shop.sections = parseSections(shopMenus.sections, orderType);
          shop.categories = parseCategories(shopMenus.categories, orderType);
          shop.shopId = shopId;
          store.dispatch({
            type: UPDATE_SHOP,
            payload: { ...shop, shopIsLoaded: true },
          });

          listenOffers(shopId, orderType);
          const pendingOrder = store.getState().pendingOrderReducer;
          checkIfCustomerAddressValid(
            pendingOrder?.address,
            pendingOrder?.orderType,
            shopId,
          );
        }
      });
    }
  });

  listenOrders(shopId);
  return true;
};

export const listenDriverData = async (driverId, chargeId, delivery) => {
  const database =
    delivery.freelance ||
      delivery.nature !== DELIVERY_FLEET_CONFIGURATION_TYPE.FLEET
      ? getFirebaseFleet()
      : getFirebaseModule();
  const db = getDatabase(database);
  const tableName =
    delivery.nature === DELIVERY_FLEET_CONFIGURATION_TYPE.FLEET
      ? DRIVERS_TYPE.DRIVERS
      : DRIVERS_TYPE.EXTERNAL_DRIVERS;

  const driverRef = ref(db, `/${tableName}/${driverId}`);
  off(driverRef);

  onValue(driverRef, (snapshot) => {
    if (snapshot.exists()) {
      const { firstName, lastName, lat, long, numero } = snapshot.val();
      const driverData = {
        driverFirstName: firstName,
        driverLastName: lastName,
        driverLocation: { latitude: lat, longitude: long },
        driverNumero: numero,
      };
      store.dispatch({
        type: UPDATE_DRIVERS_DATA,
        payload: { driverData, chargeId },
      });
    }
  });
};

export const unlistenDriverData = async (driverId, chargeId, delivery) => {
  const isFleet = delivery.nature === DELIVERY_FLEET_CONFIGURATION_TYPE.FLEET;
  const database =
    delivery.freelance || !isFleet ? getFirebaseFleet() : getFirebaseModule();
  const db = getDatabase(database);

  const tableName = isFleet
    ? DRIVERS_TYPE.DRIVERS
    : DRIVERS_TYPE.EXTERNAL_DRIVERS;
  off(ref(db, `/${tableName}/${driverId}`));

  store.dispatch({
    type: UPDATE_DRIVERS_DATA,
    payload: { driverData: null, chargeId },
  });
};
